import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allManagers } from 'app/mocks/data/park/managers'

import { api } from 'app/utils/constants'

import {
    PriceTableCreatePayload,
    PriceTableCreateRequest,
} from 'app/types/catalogue/priceTable'

export const createPriceTable = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.priceTables.LIST}`,
    async ({ request }) => {
        const payload = await request.json()

        const payloadParsed = PriceTableCreatePayload.safeParse(payload)

        // Wrong payload
        if (!payloadParsed.success) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json<PriceTableCreateRequest>({
            id: 99,
            ...payloadParsed.data,
            client: allManagers.find(
                (manager) => manager.id === payloadParsed.data.client,
            ),
        })
    },
)
